import { api } from './api'

export interface ComplianceCheck {
  id: string
  project_id: string
  check_type: string
  status: 'pending' | 'in_progress' | 'compliant' | 'non_compliant' | 'waived' | 'not_applicable'
  severity: 'low' | 'medium' | 'high' | 'critical'
  due_date?: string
  completed_date?: string
  notes?: string
  created_at: string
  updated_at: string
}

export interface ComplianceScore {
  project_id: string
  overall_score: number
  compliant_count: number
  non_compliant_count: number
  pending_count: number
  waived_count: number
  categories: {
    [key: string]: {
      score: number
      total_checks: number
      compliant_checks: number
    }
  }
}

export interface ComplianceReport {
  project_id: string
  project_name: string
  compliance_score: number
  total_checks: number
  status_breakdown: {
    compliant: number
    non_compliant: number
    pending: number
    in_progress: number
    waived: number
    not_applicable: number
  }
  high_risk_items: ComplianceCheck[]
  upcoming_deadlines: ComplianceCheck[]
  recent_updates: ComplianceCheck[]
}

export const complianceService = {
  async getComplianceChecks(projectId?: string, status?: string): Promise<ComplianceCheck[]> {
    const params: any = {}
    if (projectId) params.project_id = projectId
    if (status) params.status = status
    
    const response = await api.get('/compliance/checks', { params })
    return response.data
  },

  async createComplianceCheck(projectId: string, checkType: string): Promise<ComplianceCheck> {
    const response = await api.post('/compliance/check', {
      project_id: projectId,
      check_type: checkType
    })
    return response.data
  },

  async updateComplianceCheck(checkId: string, updates: Partial<ComplianceCheck>): Promise<ComplianceCheck> {
    const response = await api.put(`/compliance/check/${checkId}`, updates)
    return response.data
  },

  async checkProjectCompliance(projectId: string): Promise<ComplianceReport> {
    const response = await api.post(`/compliance/project/${projectId}/check`)
    return response.data
  },

  async getComplianceScore(projectId: string): Promise<ComplianceScore> {
    const response = await api.get(`/compliance/score/${projectId}`)
    return response.data
  }
}